import { Component, Input } from '@angular/core'
import { FormAtylBase } from '../../../../form-atyl-base'


@Component({
	selector: 'atyl-form-input-divider',
	templateUrl: './form-input-divider.component.html',
	styleUrls: ['./form-input-divider.component.scss']
})
export class FormInputDividerComponent {

	@Input() forminput: FormAtylBase<any>
	@Input() disabled: boolean

}
